import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const healthData: AppRouteModule = {
  path: '/health-data',
  name: 'HealthData',
  component: LAYOUT,
  redirect: '/health-data/index',
  meta: {
    orderNo: 3,
    icon: 'tdesign:chart-add',
    title: t('routes.nurse.healthData'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'HealthDataIndex',
      component: () => import('/@/views/nurse/health-data/index.vue'),
      meta: {
        icon: 'tdesign:chart-add',
        title: t('routes.nurse.healthData'),
        hideMenu: true,
      },
    },
  ],
};

export default healthData;
